// Free Shipping Bar – Land direkt von Shopify Markets (kein externer API-Call)
(function () {
  var country_code = document.documentElement.getAttribute('data-country_code');
  var currency_code = document.querySelector(".mini-cart")?.getAttribute("currency_code");

  if (!country_code) return;

  var matchFound = freeshippingArr.some(function (item) {
    return item.country_code === country_code && item.currency_code === currency_code;
  });

  if (!matchFound) {
    document.body.classList.add("shippingbar_disabled");
  }
})();


// -------------------------------------------------------
// Bundle Varianten-Bild Fix
// Liest option1/option2 direkt aus – kein master select nötig
// -------------------------------------------------------
(function () {

  const variantCache = {};

  async function fetchVariants(handle) {
    if (variantCache[handle]) return variantCache[handle];
    try {
      const res = await fetch('/products/' + handle + '.js');
      const data = await res.json();
      variantCache[handle] = data.variants;
      return data.variants;
    } catch (e) { return null; }
  }

  function getSelectedOptions(el) {
    const opts = [];
    // Alle option-Selects und Radio-Inputs auslesen
    [1, 2, 3].forEach(function(i) {
      const radio = el.querySelector('input[name="option' + i + '"]:checked');
      if (radio) { opts.push(radio.value); return; }
      const select = el.querySelector('select[name="option' + i + '"]');
      if (select && select.value) opts.push(select.value);
    });
    return opts;
  }

  function setMainImage(variant) {
    if (!variant || !variant.featured_image) return;
    const fi = variant.featured_image;
    const baseSrc = fi.src.split('?')[0];
    const buildSrc = function(w) { return baseSrc.replace(/(\.[^.]+)$/, '_' + w + 'x$1'); };
    const mainImg = document.querySelector('.product__media-item.is-selected img');
    if (mainImg) {
      mainImg.src = buildSrc(1800);
      mainImg.srcset = [400,600,800,1000,1200,1400,1800]
        .map(function(w) { return buildSrc(w) + ' ' + w + 'w'; }).join(', ');
      if (fi.alt) mainImg.alt = fi.alt;
    }
  }

  function attachListeners(el) {
    const handle = el.getAttribute('handle');
    if (!handle) return;

    let timer = null;
    const onChange = function() {
      clearTimeout(timer);
      timer = setTimeout(async function() {
        const variants = await fetchVariants(handle);
        if (!variants) return;
        const selected = getSelectedOptions(el);
        const matched = variants.find(function(v) {
          return selected.every(function(opt) { return v.options.includes(opt); });
        });
        setMainImage(matched);
      }, 150);
    };

    // Auf Radio-Inputs und Selects hören
    el.querySelectorAll('input[type="radio"]').forEach(function(r) {
      r.addEventListener('change', onChange);
    });
    el.querySelectorAll('select.visually-hidden').forEach(function(s) {
      s.addEventListener('change', onChange);
    });
    // Combo-Box Buttons
    el.querySelectorAll('.combo-box__option-item').forEach(function(btn) {
      btn.addEventListener('click', function() { setTimeout(onChange, 50); });
    });
  }

  function init() {
    document.querySelectorAll('product-variants[data-template-suffix="bundle"]').forEach(function(el) {
      if (!el.dataset.bundleFix) {
        el.dataset.bundleFix = '1';
        attachListeners(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__bundleVariantFix_attachListeners = attachListeners;

})();

// -------------------------------------------------------
// Combo-Box Suchfeld
// Filtert Optionen live beim Tippen
// -------------------------------------------------------
(function () {
  function initComboBoxSearch(comboBox) {
    const input = comboBox.querySelector('.combo-box__search-input');
    if (!input) return;

    input.addEventListener('input', function () {
      const query = this.value.toLowerCase().trim();
      comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
        const match = item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
      });
    });

    // Suchfeld leeren wenn Combo-Box geschlossen wird
    comboBox.addEventListener('close', function () {
      input.value = '';
      comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
        item.hidden = false;
      });
    });

    // Beim Öffnen Fokus auf Suchfeld
    const observer = new MutationObserver(function () {
      if (comboBox.hasAttribute('open')) {
        setTimeout(() => input.focus(), 200);
      } else {
        input.value = '';
        comboBox.querySelectorAll('.combo-box__option-item').forEach(function (item) {
          item.hidden = false;
        });
      }
    });
    observer.observe(comboBox, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('combo-box').forEach(function (cb) {
      if (!cb.dataset.searchInit) {
        cb.dataset.searchInit = '1';
        initComboBoxSearch(cb);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__comboBoxSearch_init = initComboBoxSearch;
})();


// -------------------------------------------------------
// Ketten Image Swatches (ewph-v2)
// Liest ketten_bilder JSON aus dem Metafeld und
// aktualisiert Bilder wenn Farbe (Gold/Silber) wechselt
// -------------------------------------------------------
(function () {

  function updateKettenImages(swatchList, farbe) {
    const raw = swatchList.getAttribute('data-ketten-bilder');
    if (!raw) return;

    let kettenBilder;
    try {
      // Shopify gibt Metafeld-Hash manchmal als Ruby-Syntax aus (=> statt :)
      const cleaned = raw.replace(/=>/g, ':');
      kettenBilder = JSON.parse(cleaned);
    } catch (e) {
      return;
    }


    const farbenBilder = kettenBilder[farbe] || kettenBilder[farbe.toLowerCase()] || {};

    swatchList.querySelectorAll('img[data-kette]').forEach(function (img) {
      const kette = img.getAttribute('data-kette');
      // Suche case-insensitive
      const bildUrl = Object.keys(farbenBilder).reduce(function (found, key) {
        return found || (key.toLowerCase() === kette.toLowerCase() ? farbenBilder[key] : null);
      }, null);

      if (bildUrl) {
        img.classList.add('is-loading');
        const newImg = new Image();
        newImg.onload = function () {
          img.src = bildUrl;
          img.classList.remove('is-loading');
        };
        newImg.src = bildUrl;
      }
    });
  }

  function getSelectedFarbe(productVariants) {
    // Alle checked radios die NICHT im image-swatch-list stecken
    const radios = productVariants.querySelectorAll('input[type="radio"]:checked');
    for (const r of radios) {
      if (!r.closest('.image-swatch-list')) return r.value;
    }
    return null;
  }

  function initKettenSwatches(swatchList) {
    const productVariants = swatchList.closest('product-variants');
    if (!productVariants) return;

    // Initial: Farbe ermitteln und Bilder setzen
    function refreshImages() {
      const farbe = getSelectedFarbe(productVariants);
      if (farbe) updateKettenImages(swatchList, farbe);
    }

    refreshImages();

    // Auf Farb-Änderung lauschen (alle Radios die NICHT im image-swatch-list sind)
    productVariants.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (!radio.closest('.image-swatch-list')) {
        radio.addEventListener('change', refreshImages);
      }
    });
  }

  function init() {
    const lists = document.querySelectorAll('.image-swatch-list');
    lists.forEach(function (list) {
      if (!list.dataset.ketteInit) {
        list.dataset.ketteInit = '1';
        initKettenSwatches(list);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__kettenSwatches_init = initKettenSwatches;

})();


// -------------------------------------------------------
// Bundle: Farb-Selektor visuell vor Ketten-Selektor
// WICHTIG: CSS order statt DOM-Reorder, damit
// _getSelectedOptionValues() korrekt option1/option2 liest
// und ausverkaufte Varianten richtig erkannt werden.
// -------------------------------------------------------
(function () {

  function reorderSelectorsCSS(productVariants) {
    productVariants.style.display = 'flex';
    productVariants.style.flexDirection = 'column';

    var colorSelector = productVariants.querySelector('.product-form__option-selector[data-selector-type="color"]');
    if (colorSelector) {
      colorSelector.style.order = '-1';
    }
  }

  function init() {
    document.querySelectorAll('product-variants[data-template-suffix="bundle"]').forEach(function (el) {
      if (!el.dataset.reorderDone) {
        el.dataset.reorderDone = '1';
        reorderSelectorsCSS(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // MutationObserver wird unten zentral registriert
  window.__bundleReorder_init = reorderSelectorsCSS;

})();


// -------------------------------------------------------
// Zentraler MutationObserver (statt 4 separate)
// Ein einziger Observer mit Debounce, statt 4 die bei
// jeder DOM-Änderung einzeln querySelectorAll feuern.
// -------------------------------------------------------
(function () {
  var debounceTimer = null;

  function processNewElements() {
    // Bundle Variant Fix
    if (window.__bundleVariantFix_attachListeners) {
      document.querySelectorAll('product-variants[data-template-suffix="bundle"]:not([data-bundle-fix])').forEach(function(el) {
        el.dataset.bundleFix = '1';
        window.__bundleVariantFix_attachListeners(el);
      });
    }

    // Combo-Box Search
    if (window.__comboBoxSearch_init) {
      document.querySelectorAll('combo-box:not([data-search-init])').forEach(function (cb) {
        cb.dataset.searchInit = '1';
        window.__comboBoxSearch_init(cb);
      });
    }

    // Ketten Image Swatches
    if (window.__kettenSwatches_init) {
      document.querySelectorAll('.image-swatch-list:not([data-kette-init])').forEach(function (list) {
        list.dataset.ketteInit = '1';
        window.__kettenSwatches_init(list);
      });
    }

    // Bundle Reorder
    if (window.__bundleReorder_init) {
      document.querySelectorAll('product-variants[data-template-suffix="bundle"]:not([data-reorder-done])').forEach(function (el) {
        el.dataset.reorderDone = '1';
        window.__bundleReorder_init(el);
      });
    }
  }

  new MutationObserver(function () {
    if (debounceTimer) return;
    debounceTimer = requestAnimationFrame(function () {
      debounceTimer = null;
      processNewElements();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();


// Klaviyos nativen BIS-Button verstecken – wir nutzen unseren eigenen
(function() {
  var style = document.createElement('style');
  style.textContent = '.klaviyo-bis-button-container { display: none !important; } .kl-private-reset-css-Xuajs1 { display: none !important; } .klaviyo-bis-custom-button { background-position: 100% 100% !important; }';
  document.head.appendChild(style);
})();

// -------------------------------------------------------
// Klaviyo Back in Stock – Eigenes Formular via direkter API
//
// Wir umgehen Klaviyos DOM-Scanning komplett und posten
// die E-Mail-Adresse direkt an Klaviyos Subscribe-Endpoint.
// Company ID: WzUNw5
// -------------------------------------------------------
(function () {

  var KLAVIYO_COMPANY_ID = 'WzUNw5';
  var SHOP_DOMAIN = 'dorigine-com.myshopify.com';

  // Modal HTML einfügen
  function createModal() {
    if (document.getElementById('bis-modal')) return;
    var modal = document.createElement('div');
    modal.id = 'bis-modal';
    modal.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;align-items:center;justify-content:center;';
    modal.innerHTML = '<div style="background:#fff;padding:32px;max-width:400px;width:90%;border-radius:8px;position:relative;">' +
      '<button id="bis-modal-close" type="button" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:20px;cursor:pointer;">✕</button>' +
      '<h3 style="margin:0 0 8px;font-size:18px;">Benachrichtigen, sobald verfügbar</h3>' +
      '<p style="margin:0 0 16px;font-size:14px;color:#666;">Wir informieren dich per E-Mail sobald diese Variante wieder verfügbar ist.</p>' +
      '<input id="bis-email-input" type="email" placeholder="Deine E-Mail-Adresse" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;margin-bottom:12px;">' +
      '<button id="bis-submit-btn" type="button" style="width:100%;padding:12px;background:#000;color:#fff;border:none;border-radius:4px;font-size:14px;cursor:pointer;">Benachrichtigen</button>' +
      '<p id="bis-message" style="margin:8px 0 0;font-size:13px;text-align:center;"></p>' +
    '</div>';
    document.body.appendChild(modal);

    document.getElementById('bis-modal-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    document.getElementById('bis-submit-btn').addEventListener('click', submitBIS);
  }

  function openModal(variantId, productId) {
    createModal();
    var modal = document.getElementById('bis-modal');
    modal.dataset.variantId = variantId;
    modal.dataset.productId = productId;
    modal.style.display = 'flex';
    document.getElementById('bis-email-input').value = '';
    document.getElementById('bis-message').textContent = '';
    setTimeout(function() { document.getElementById('bis-email-input').focus(); }, 100);
  }

  function closeModal() {
    var modal = document.getElementById('bis-modal');
    if (modal) modal.style.display = 'none';
  }

  function submitBIS() {
    var modal = document.getElementById('bis-modal');
    var email = document.getElementById('bis-email-input').value.trim();
    var variantId = modal.dataset.variantId;
    var msg = document.getElementById('bis-message');
    var btn = document.getElementById('bis-submit-btn');

    if (!email || !email.includes('@')) {
      msg.style.color = 'red';
      msg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      // 202 = Erfolg, kein Body
      if (res.status === 202) {
        msg.style.color = 'green';
        msg.textContent = 'Du wirst benachrichtigt sobald die Variante verfügbar ist!';
        btn.textContent = '✓ Gespeichert';
        setTimeout(closeModal, 2500);
      } else {
        throw new Error('Status ' + res.status);
      }
    })
    .catch(function() {
      msg.style.color = 'red';
      msg.textContent = 'Fehler. Bitte versuche es erneut.';
      btn.disabled = false;
      btn.textContent = 'Benachrichtigen';
    });
  }

  function updateBisWrapper(formId, variant) {
    var wrapper = document.querySelector('.klaviyo-bis-wrapper[data-form-id="' + formId + '"]');
    if (!wrapper) return;

    if (variant && !variant.available) {
      var trigger = wrapper.querySelector('[klaviyo-bis-trigger]');
      if (trigger) trigger.setAttribute('data-variant-id', variant.id);
      wrapper.style.removeProperty('display');
    } else {
      wrapper.style.display = 'none';
    }
  }

  function initBisButtons() {
    document.querySelectorAll('.klaviyo-bis-custom-button:not([data-bis-init])').forEach(function (btn) {
      btn.dataset.bisInit = '1';
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.klaviyo-bis-wrapper');
        if (!wrapper) return;
        var trigger = wrapper.querySelector('[klaviyo-bis-trigger]');
        var variantId = trigger ? trigger.getAttribute('data-variant-id') : null;
        var productId = trigger ? trigger.getAttribute('data-product-id') : null;
        if (variantId && productId) openModal(variantId, productId);
      });
    });
  }

  function initKlaviyoBIS() {
    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      if (form.dataset.klaviyoBisInit) return;
      form.dataset.klaviyoBisInit = '1';
      form.addEventListener('variant:changed', function (e) {
        updateBisWrapper(form.getAttribute('id'), e.detail && e.detail.variant);
      });
    });
    initBisButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoBIS);
  } else {
    initKlaviyoBIS();
  }

  new MutationObserver(function () {
    document.querySelectorAll('form[is="product-form"]:not([data-klaviyo-bis-init])').forEach(function (form) {
      form.dataset.klaviyoBisInit = '1';
      form.addEventListener('variant:changed', function (e) {
        updateBisWrapper(form.getAttribute('id'), e.detail && e.detail.variant);
      });
    });
    initBisButtons();
  }).observe(document.body, { childList: true, subtree: true });

})();
